var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFootertwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.827,
    height: 26.867,
    viewBox: "0 0 32.827 26.867",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_043-twitter",
    "data-name": "043-twitter",
    d: "M12.247,26.868A28.167,28.167,0,0,1,7.9,26.522a20.418,20.418,0,0,1-5.951-2.166L0,23.293,2.106,22.6c2.3-.757,3.7-1.226,5.436-1.962a7.231,7.231,0,0,1-3.717-4.307l-.49-1.487.4.061a7.305,7.305,0,0,1-.915-1.128A6.925,6.925,0,0,1,1.646,9.66l.092-1.3.777.3a7.265,7.265,0,0,1-.7-1.973,7.509,7.509,0,0,1,.8-5.056L3.288.392l.905,1.087A16.663,16.663,0,0,0,14.988,7.557a6.456,6.456,0,0,1,.392-3.43,6.422,6.422,0,0,1,2.611-2.994A7.842,7.842,0,0,1,22.543.015a7.27,7.27,0,0,1,4.469,1.843,15,15,0,0,0,1.636-.546c.359-.135.765-.288,1.274-.464L31.8.2,30.574,3.7c.081-.007.164-.013.251-.016l2-.091L31.644,5.206c-.068.093-.085.119-.109.155-.1.144-.214.323-1.839,2.492a3.06,3.06,0,0,0-.572,1.993,18.848,18.848,0,0,1-1.029,7.581,13.415,13.415,0,0,1-3.6,5.334,15.9,15.9,0,0,1-7.539,3.645A23.208,23.208,0,0,1,12.247,26.868Zm0,0",
    transform: "translate(0 0)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootertwitter);
export default __webpack_public_path__ + "static/media/footertwitter.d1fa08e7906dd3c0e1cb76f8f6b0993a.svg";
export { ForwardRef as ReactComponent };